import { render, staticRenderFns } from "./CatIcon.vue?vue&type=template&id=8ad366bc&scoped=true"
import script from "./CatIcon.vue?vue&type=script&lang=ts"
export * from "./CatIcon.vue?vue&type=script&lang=ts"
import style0 from "./CatIcon.vue?vue&type=style&index=0&id=8ad366bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad366bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ad366bc')) {
      api.createRecord('8ad366bc', component.options)
    } else {
      api.reload('8ad366bc', component.options)
    }
    module.hot.accept("./CatIcon.vue?vue&type=template&id=8ad366bc&scoped=true", function () {
      api.rerender('8ad366bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/CatIcon.vue"
export default component.exports